import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralizeWithCount } from "@common/helpers/string";

interface Props {
    filters: Pick<FiltersTypes, "templateIds">;
}

export const TemplateIdsFilterLabel: React.FC<Props> = ({ filters }) => {
    const templateIds = filters.templateIds;

    if (!templateIds || templateIds.length === 0) {
        return null;
    }

    return <>{pluralizeWithCount("template", templateIds.length)}</>;
};
